import { render } from "./NotFound.vue?vue&type=template&id=50917006"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"
script.render = render

export default script